const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://kimploo.github.io',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo:
      'https://hongshik-blog-bucket.s3.ap-northeast-2.amazonaws.com/photos/ubuntu-starter/0-logos/homesick-log-white-horizontal.png',
    logoLink: 'https://kimploo.github.io',
    title: '',
    githubUrl: 'https://www.github.com/kimploo',
    helpUrl: '',
    tweetText: '',
    social: `<li>
		    <a href="https://www.facebook.com/hongshikkim" target="_blank" rel="noopener">
		      <div class="twitterBtn">
		        <img src='https://hongshik-blog-bucket.s3.ap-northeast-2.amazonaws.com/photos/ubuntu-starter/0-logos/iconmonstr-facebook-1.svg' alt={'Facebook'}/>
		      </div>
		    </a>
		  </li>
			<li>
		    <a href="https://www.instagram.com/kimploo/" target="_blank" rel="noopener">
		      <div class="discordBtn">
		        <img src='https://hongshik-blog-bucket.s3.ap-northeast-2.amazonaws.com/photos/ubuntu-starter/0-logos/iconmonstr-instagram-11.svg' alt={'Instagram'}/>
		      </div>
		    </a>
		  </li>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/introduction', // add trailing slash if enabled above
      '/codeblock',
    ],
    collapsedNav: [
      '/codeblock', // add trailing slash if enabled above
    ],
    links: [{ text: 'Homesick Log', link: 'https://kimploo.github.io' }],
    frontline: false,
    ignoreIndex: true,
    title: "<div class='blueCircle'></div><a href='https://kimploo.github.io'>My Portfolio</a>",
  },
  siteMetadata: {
    title: 'Homesick Log',
    description: 'Homesick log - 개발자 김홍식의 기술 블로그',
    ogImage: null,
    docsLocation: 'https://kimploo.github.io',
    favicon:
      'https://hongshik-blog-bucket.s3.ap-northeast-2.amazonaws.com/photos/ubuntu-starter/0-logos/homeshik-log-favicon.svg',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Gatsby Gitbook Starter',
      short_name: 'GitbookStarter',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
